import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';

@Component({

  selector: 'app-footer',

  templateUrl: './footer.component.html',

  styleUrls: ['./footer.component.css']

})

export class FooterComponent implements OnInit {

    version: string = `${(<any>window).version}`;
  obj_Social: { strTM: string, strWA: string, strIG: string, strEmail: string } | any = {};

  constructor(

    private accountService: AccountService

  ) { }

  ngOnInit(): void {

    this.obj_Social.strIG = 'taxilon24';

    this.obj_Social.strEmail = 'info@taxilon.com';

    for (let i = 8; i <= 11; i++) {

      // this.accountService.dyarHelp(i).subscribe((response) => {

      //   switch (i) {

      //     case 8: {

      //       this.obj_Social.strTM = response.toString();
      //       break;

      //     }

      //     case 9: {

      //       this.obj_Social.strWA = response.toString();
      //       break;

      //     }

      //     case 10: {

      //       this.obj_Social.strIG = response.toString();
      //       break;

      //     }

      //     case 11: {

      //       this.obj_Social.strEmail = response.toString();
      //       break;


      //     }

      //   }

      // });

    }

  }

}
